export default __webpack_public_path__ + "static/media/16.79d89237.jpeg";